import { View } from 'react-native';
import React from 'react';
import Icon from '../../icon/Icon';
import { ColorTokens, IconSizeTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
const InfoSection = ({ title, icon, }) => {
    return (React.createElement(View, { style: { borderRadius: 8, borderWidth: 1, borderColor: '#E4E7EC', flex: 1, paddingVertical: 12, paddingHorizontal: 8 } },
        React.createElement(View, { style: { alignItems: 'center' } },
            React.createElement(Icon, { name: icon, size: IconSizeTokens.XL })),
        React.createElement(View, { style: { marginTop: 4, marginHorizontal: 8 } },
            React.createElement(Typography, { label: title, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }))));
};
export default InfoSection;
